import ContentPage from '@/components/feature/ContentPage';

export default function PrivacyPage() {
  return (
    <ContentPage
      title="Privacy Policy"
      metaTitle="Privacy Policy | CSSBuyBR.TOP"
      metaDescription="CSSBuyBR.TOP privacy policy. Learn how we handle your data, cookies, and browsing information."
      content={
        <div className="space-y-6">
          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Information We Collect</h2>
            <p>CSSBuyBR.TOP is a content resource website. We do not collect personal data from visitors unless you voluntarily submit information through our contact form.</p>
            <p className="mt-2">When you visit our site, standard web analytics may collect:</p>
            <ul className="list-disc list-inside space-y-1.5 ml-2 mt-2">
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>Pages visited and time spent</li>
              <li>Referral source</li>
              <li>Approximate geographic location (country/region level)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">How We Use Information</h2>
            <p>We use collected information solely to:</p>
            <ul className="list-disc list-inside space-y-1.5 ml-2 mt-2">
              <li>Improve website content and user experience</li>
              <li>Understand which resources are most helpful</li>
              <li>Respond to contact form submissions</li>
              <li>Monitor website performance and security</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Cookies</h2>
            <p>This website may use cookies for:</p>
            <ul className="list-disc list-inside space-y-1.5 ml-2 mt-2">
              <li>Language preference storage</li>
              <li>Basic analytics</li>
              <li>Website functionality and performance</li>
            </ul>
            <p className="mt-2">You can disable cookies in your browser settings, though this may affect some functionality.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Third-Party Links</h2>
            <p>This website contains links to external sites (including our main site at kaspreadsheet.com). We are not responsible for the privacy practices or content of third-party websites. We encourage you to review the privacy policies of any external sites you visit.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Data Security</h2>
            <p>We take reasonable measures to protect any information collected. However, no internet transmission is completely secure. We cannot guarantee absolute security of data transmitted to or from our website.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Changes to This Policy</h2>
            <p>We may update this privacy policy from time to time. Changes will be posted on this page with an updated date. We encourage visitors to review this policy periodically.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Contact</h2>
            <p>If you have questions about this privacy policy, please contact us through our contact page.</p>
          </section>

          <p className="text-sm text-foreground-500 italic">Last updated: August 26, 2026</p>
        </div>
      }
    />
  );
}